<template>
  <el-submenu :index="index">
    <template slot="title">{{ title }}</template>
    <template v-for="item in menu.exploreList">
      <template v-if="!item.leaf">
        <loop-item :key="item.id" :menu="item" :index="item.id" :title="item.name" />
      </template>
      <el-menu-item v-else :key="item.id">{{ item.name }}</el-menu-item>
    </template>
  </el-submenu>
</template>

<script>
export default {
  name: 'LoopItem',
  props: {
    menu: {
      type: Object,
      default: () => null
    },
    index: {
      type: String,
      default: () => ''
    },
    title: {
      type: String,
      default: () => ''
    }
  }
}
</script><style scoped />
